import React, { useState } from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  View
} from 'react-native';
import { useIsomorphicLayoutEffect } from '@lib/hooks';
import FastImage from 'react-native-fast-image'
import { width, height, colors, radius, margin } from '@styles/common'
import helper from '@utils/helper'

function EventItem ({ item, navigation }) {
  const [sizeMode, setSizeMode] = useState('xl');
  useIsomorphicLayoutEffect(() => {
    const resizeObserver = new ResizeObserver(([entry]) => {
      const { contentBoxSize: [{ inlineSize }] } = entry;
      if (inlineSize >= 1200) {
        setSizeMode('xxl')
      }
      if (inlineSize < 1200 && inlineSize >= 1120) {
        setSizeMode('xl')
      }
      if (inlineSize < 1120 && inlineSize >= 1040) {
        setSizeMode('lg')
      }
      if (inlineSize < 1040 && inlineSize > 960) {
        setSizeMode('md')
      }
      if (inlineSize < 961) {
        setSizeMode('sm')
      }
    });
    resizeObserver.observe(document.body);
    return () => {
      resizeObserver.unobserve(document.body)
    }
  }, [])
  return (
    <TouchableOpacity activeOpacity={0.8} onPress={() => {
      navigation?.navigate?.(item)
      helper.trackEvent('NewHome Click EventItem ' + item.title, { item: JSON.stringify(item) });
    }}>
      <View style={StyleSheet.flatten(sizeMode === 'sm' ? styles.view : null)}>
        <FastImage
          style={StyleSheet.flatten(style[sizeMode])}
          source={{ uri: item.image }}
        />
      </View>
    </TouchableOpacity>
  )
}
const styles = StyleSheet.create({
  view: {
    marginRight: margin.m20
  },
  eventsRowXxlStyle: {
    width: '288px',
    height: '140px',
    borderRadius: radius.r16,
    backgroundColor: colors.white5
  },
  eventsRowXlStyle: {
    width: '262px',
    height: '130px',
    borderRadius: radius.r16,
    backgroundColor: colors.white5
  },
  eventsRowLgStyle: {
    width: '247px',
    height: '123px',
    borderRadius: radius.r16,
    backgroundColor: colors.white5
  },
  eventsRowMdStyle: {
    width: '225px',
    height: '112px',
    borderRadius: radius.r16,
    backgroundColor: colors.white5
  },
  eventsRowH5Style: {
    width: width.w400,
    height: height.h200,
    borderRadius: radius.r16,
    backgroundColor: colors.white5
  }
})

const style = {
  xxl: styles.eventsRowXxlStyle,
  xl: styles.eventsRowXlStyle,
  lg: styles.eventsRowLgStyle,
  md: styles.eventsRowMdStyle,
  sm: styles.eventsRowH5Style
}

const MemoizedEventItem = React.memo(EventItem);
export default MemoizedEventItem
